
import "./Header.scss";
import { Link } from "react-router-dom";
import logo from "../../../src/assets/header/logos/matte_logo.png"
import { useState } from "react";

import arrow from "../../assets/online_business/arrow.gif"
function Header() {
  const [headerOpen, setHeaderOpen] = useState(false)
  return (
    <>
      <div className="parent header-parent">
        <div className="cont header-container">

          <div className="logo-wrapper">
            <Link className="logo" to="/"> <img src={logo} alt="" /> </Link>
            <span>A bridge from local to global </span>
          </div>


          <div className="links">

            <Link to="/seller-benefits" className="sell-online">
              Seller Benefits
            </Link>

            <Link to="/help-support" className="sell-online">
              Help & Support
            </Link>

            <Link to="/gst" className="sell-online">
              Don't have GST?
            </Link>

            <Link to="/login" className="border-btn">
              Login
            </Link>
            <Link className="btn" to="/register" target="blank">
              Register Your Business
            </Link>
          </div>

          <div className="responsive_header">
            <Link to="/login" className="border-btn">
              Login
            </Link>
            <Link className="btn" to="/register">
              Register
            </Link>

            <div className={headerOpen ? "hamburger active" : "hamburger"} onClick={() => setHeaderOpen(!headerOpen)} >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        <div class={headerOpen ? "responsive_header_menu active" : "responsive_header_menu"}>
          <Link to="/seller-benefits" className="sell-online" onClick={() => setHeaderOpen(false)} >
            Seller Benefits
          </Link>

          <Link to="/help-support" className="sell-online" onClick={() => setHeaderOpen(false)} >
            Help & Support
          </Link>

          <Link to="/gst" className="sell-online" onClick={() => setHeaderOpen(false)} >
            Don't have GST?
          </Link>

          <Link to="/login" onClick={() => setHeaderOpen(false)} >
            Login
          </Link>
        </div>
      </div>
      <div class="header_tab parent">
        <div class="header_tab_cont cont">
                 <p>Go to Main Website <a target="blank" href="https://jungleboosh.com/">Click here</a></p>
                 <img src={arrow} alt=""/>
                 
        </div>
      </div>
    </>
  );
}

export default Header;
